(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    define(['torso/modules/View',
            'app/user/userService',
            'app/applicationUtils'], factory);
  } else if (typeof exports === 'object') {
    // CommonJS-style exports
    var TorsoView = require('backbone-torso/modules/View'),
        userService = require('./../user/userService'),
        applicationUtils = require('./../applicationUtils');

    module.exports = factory(TorsoView, userService, applicationUtils);
  } else {
    throw 'Only AMD and CommonJS imports are supported.';
  }
}(this, function(TorsoView, userService,applicationUtils) {
  'use strict';

  /**
   * @class SecureMessageView
   * @constructor
   * @param option {Object}
   *   @param options.model {Torso.Model}
   *   @param options.context.patientVecnaId {String}
   */
  return TorsoView.extend({
    /**
     * @method initialize
     * @override
     * @param options {Object}
     *   @param options.model {Torso.Model}
     *   @param options.context.patientVecnaId {String}
     */
    initialize: function(options) {
      options = options || {};
      var context = options.context || {};
      this._patientVecnaId = context.patientVecnaId;
      this.listenTo(userService.currentDemographicsModel, 'change:messagingUsername', this.render);
      userService.fetchModels();
    },

    /**
     * @method prepare
     * @override
     */
    prepare: function() {
      var context = TorsoView.prototype.prepare.apply(this);
      var patientUsername = userService.currentDemographicsModel.get('messagingUsername');
      var isOnAdminTool = applicationUtils.currentApplication === applicationUtils.APPLICATIONS.ADMIN_TOOL;

      context.secureMessage = this.model.toJSON();
      context.isStatusUnread = this.model._isMessageUnread(patientUsername);
      context.patientVecnaId = this._patientVecnaId;
      context.currentApplication = applicationUtils.currentApplication;
      context.MESSAGE_TYPES = this.model.MESSAGE_TYPES;
      context.BILL_STATUSES = this.model.BILL_STATUSES;
      context.APPLICATIONS = applicationUtils.APPLICATIONS;
      context.isOnAdminTool = isOnAdminTool;
      return context;
    }
  });
}));
